import { useAuth } from 'context/AuthContext';
import { useGetCurrentSessionUser } from 'hooks/useGetCurrentSessionUser';
import { currentSelectedClientType } from 'features/Client/useSwitchClientList';
import { saveNewAccountGroupDetails } from './api';
import { SaveNewAccountGroupRequest } from './types';
import { useMutation, useQueryClient } from '@tanstack/react-query';


export function useSaveNewAccountGroupDetails() {
    const queryClient = useQueryClient();
    const { user } = useAuth();
    const currentSelectedClient = useGetCurrentSessionUser('currentSelectedClient') as currentSelectedClientType;
    const subClientId = currentSelectedClient?.clientId ?? user?.clientId;

    // MUTATION
    const mutation = useMutation({
        mutationFn: async (payload: Omit<SaveNewAccountGroupRequest, 'subClientId'>) => await saveNewAccountGroupDetails({ ...payload, subClientId }),
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ["changeAccountGroupsInitData", variables.accountNumber],
            });
        }
    });

    return mutation;
}